import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const MLTheoryAstro = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        <iframe
          src="/ml-theory/index.html"
          title="ML Theory Q&A"
          className="w-full h-[80vh] border-0"
        />
      </main>
      <Footer />
    </div>
  );
};

export default MLTheoryAstro;
